import { render, staticRenderFns } from "./SGBind.vue?vue&type=template&id=11dc2aef&v-if=true&"
import script from "./SGBind.vue?vue&type=script&lang=js&"
export * from "./SGBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports